import type {z} from "zod";
import {ListOfferTemplatesQueryParams} from "@project/sdk/sales/zod";

export const listOfferTemplatesSearchSchema = ListOfferTemplatesQueryParams.extend({
  page: ListOfferTemplatesQueryParams.shape.page.catch(1),
  perPage: ListOfferTemplatesQueryParams.shape.perPage.catch(20),
  sortKey: ListOfferTemplatesQueryParams.shape.sortKey.catch("name"),
  sortDir: ListOfferTemplatesQueryParams.shape.sortDir.catch("asc"),
  q: ListOfferTemplatesQueryParams.shape.q.catch(undefined),
  state: ListOfferTemplatesQueryParams.shape.state.catch(undefined),
  language: ListOfferTemplatesQueryParams.shape.language.catch(undefined),
  currencyCode: ListOfferTemplatesQueryParams.shape.currencyCode.catch(undefined),
});
export type ListOfferTemplatesSearchInput = z.input<typeof listOfferTemplatesSearchSchema>;
export type ListOfferTemplatesSearch = z.output<typeof listOfferTemplatesSearchSchema>;
